import { useDashboardManutencao } from "core/features/manutencao/hooks/useDashboardManutencoes";
import moment from "moment";
import ProximasManutencoes from "./components/ProximasManutencoes";

function CardManutencoes() {
  const { data, isLoading: loading } = useDashboardManutencao({
    dataInicio: moment().format("YYYY-MM-DD"),
    dataFim: moment().format("YYYY-MM-DD"),
  });

  return <ProximasManutencoes data={data || undefined} loading={loading} />;
}

export default CardManutencoes;
